<template>
  <div class="container">
    <SuccesPage class="pt-5" />
  </div>
</template>

<script>
import SuccesPage from "@/components/Catalog/SuccesPage.vue";
export default {
  components: {
    SuccesPage
  }
};
</script>
<style scoped></style>
